"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    groupLabel: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center'
    },
    groupAvatar: {
        marginRight: 8,
        flexShrink: 0
    }
});
//# sourceMappingURL=workflowGroup.style.js.map